module.exports = __webpack_public_path__ + "media/images/actualVsCapacity-12bdf4e7.png";